import React from "react";
import { MenuItem, Select, Typography } from "@mui/material";

// Rows-per-page choices offered in an expanded table (the normal page view keeps its default).
// Rows per page on the page itself.
export const DEFAULT_PAGE_SIZE = 25;
export const EXPANDED_PAGE_SIZES = [25, 50, 100];

const PageSizeSelect = ({ value, onChange, options = EXPANDED_PAGE_SIZES }) => (
  <>
    <Typography sx={{ fontSize: "13px", color: "#666" }} component="label" id="rows-per-page-label">
      Rows per page
    </Typography>
    <Select
      size="small"
      value={options.includes(value) ? value : options[0]}
      onChange={(event) => onChange(Number(event.target.value))}
      inputProps={{ "aria-labelledby": "rows-per-page-label" }}
      sx={{ fontSize: "13px", height: 30, "& .MuiSelect-select": { py: 0.25 } }}
    >
      {options.map((size) => (
        <MenuItem key={size} value={size} sx={{ fontSize: "13px" }}>
          {size}
        </MenuItem>
      ))}
    </Select>
  </>
);

export default PageSizeSelect;
